import {Injectable} from '@angular/core';
import {EventManagerService} from "@wms/app";
import {
  DataModelDesignManagerService,
  DialogService, ProjectService,
  ServiceFactoryService,
  TypeFactoryService
} from "@wms/app/services";
import {find} from "lodash-es";
import {NavigationEnd, Router} from "@angular/router";
import { BaseVariableService } from '@wms/variables';
import {msg} from "ng-packagr/lib/utils/log";

@Injectable({
  providedIn: 'root'
})
export class EmbedDbService {
  MESSAGE_KEY: any;
  cacheAPIResponse: any[];
  toOpenDialog: any;

  constructor(private eventManager: EventManagerService, private serviceFactory: ServiceFactoryService, private dataModelDesignManagerService: DataModelDesignManagerService,
              private projectService: ProjectService, private typeFactory: TypeFactoryService, private router: Router, private dialogService: DialogService, private baseVariableService: BaseVariableService) {
    this.router.events.subscribe((event: any) => {
      if(event instanceof NavigationEnd) {
      }
    });
    this.MESSAGE_KEY = {
      'CACHE_API_RESPONSE'  : 'WMS_EMBED_DB:CACHE_API_RESPONSE',
      'RELOAD_SERVICES'     : 'WMS_EMBED_DB:RELOAD_SERVICES',
      'RELOAD_DATAMODEL'    : 'WMS_EMBED_DB:RELOAD_DATAMODEL',
      'UPDATE_SERVICE_TYPES': 'WMS_EMBED_DB:UPDATE_SERVICE_TYPES',
      'WS_LOADED'           : 'WMS_EMBED_DB:WS_LOADED',
      'OPEN_DIALOG'         : 'WMS_EMBED_DB:OPEN_DIALOG',
      'SESSION_TIMEOUT'     : 'WMS_EMBED_DB:SESSION_TIMEOUT',
      'RELOAD_APP_VARIABLES': 'WMS_EMBED_DB:RELOAD_APP_VARIABLES'
    };
    this.cacheAPIResponse = [];
    this.eventManager.cacheAPIResponseObservable().subscribe((apiResponse: any) => {
      let item = find(this.cacheAPIResponse, {url: apiResponse.url});
      if (item)
        item.response = apiResponse;
      else
        this.cacheAPIResponse.push(apiResponse);
      this.postMessageToAngularJS({
        key: this.MESSAGE_KEY['CACHE_API_RESPONSE'],
        data: this.cacheAPIResponse
      });
    });
    this.listenToMessages();
  }

  reloadServices(serviceName:string = "") {
    this.serviceFactory.getServicesWithType(true);
      this.typeFactory.updateDataTypesCache(serviceName);
  }

  reloadAppVariables() {
    this.baseVariableService.reloadAppVariables();
  }

  listenToMessages() {
    window.addEventListener('message', (event) => {
      let msgData = event.data;

      switch (msgData.key) {
        case this.MESSAGE_KEY['RELOAD_SERVICES']:
            this.reloadServices(msgData.data?.dataModelName);
            break;
        case this.MESSAGE_KEY['RELOAD_APP_VARIABLES']:
            this.reloadAppVariables();
            break;
        case this.MESSAGE_KEY['RELOAD_DATAMODEL']:
            this.reloadServices(msgData.data?.dataModelName);
            this.dataModelDesignManagerService.getDataModel(this.projectService.getProjectId(), msgData.data.dataModelName, msgData.data.isDraft, null, null, true);
            if(!msgData.data.isDraft) {
              this.serviceFactory.getServiceDef(msgData.data.dataModelName, true);
            }
            break;
        case this.MESSAGE_KEY['UPDATE_SERVICE_TYPES']:
            this.serviceFactory.getServiceDef(msgData.data.serviceId, true);
             this.typeFactory.updateDataTypesCache(msgData.data?.dataModelName);
            break;
        case this.MESSAGE_KEY['WS_LOADED'] :
            this.eventManager.emitDBLoaded();
            break;
        case this.MESSAGE_KEY['SESSION_TIMEOUT'] :
            this.eventManager.emitDBLoaded();
            this.dialogService.open('sessionTimeoutDialog');
            break;
      }
    });
  }

  postMessageToAngularJS(data: any) {
    let iframe: any = document.getElementById('embededDB');
    iframe?.contentWindow.postMessage(data, '*');
  }

  onEmbedDBLoad() {
    this.postMessageToAngularJS({
      key   : this.MESSAGE_KEY['CACHE_API_RESPONSE'],
      data  : this.cacheAPIResponse
    });
  }
}
